import axios from "axios"
import AxiosInterceptors from "./AxiosInterceptors"

axios.interceptors.request.use(AxiosInterceptors.request);
axios.interceptors.response.use(AxiosInterceptors.response, AxiosInterceptors.error);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['X-Api'] = process.env.VUE_APP_X_API;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

export default axios;
